<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>{{ typ === "+" ? '产出':"消耗" }}明细</span>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin:20px 0px;"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="130px"
      >
        <template scope="scope">
          {{ scope.row.date }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in titleArr"
        :key="index"
        align="center"
        :label="item"
      >
        <el-table-column
          prop="stock_spin"
          align="center"
          label="总数"
          min-width="200"
        >
          <template scope="scope">
            {{ numFormatter2('','',scope.row.data[index].num ) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="stock_spin_avg"
          align="center"
          label="人均"
          min-width="200"
        >
          <template scope="scope">
            {{ numFormatter2('','',scope.row.data[index].avg) }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <statBar ref="statBar" :title="typ==='+'?'产出统计':'消耗统计'" />
    <GrantPercentStat v-if="rewardArr.includes(params.type )" ref="grantPercent" :params="params" :title="params.type === 14 ? '系统发放占比(机器人补发+偷补发+倍率系统补发/总发放)' : '付费发放占比(购买的体力数/总得体力数)'" />
    <div ref="chartContainer" style="width: 100%; height: 600px;margin-bottom: 50px" />
  </el-card>

</template>
<script>
import echarts from 'echarts'
import { dateStrTodate, scientificFormat } from '@/utils'
import statBar from '@/views/config/spins-consume/compents/stat-bar.vue'
import { getRidData } from '@/api/statistics/user_remain'
import GrantPercentStat from '@/views/config/spins-consume/compents/grant-percent-stat.vue'
export default {
  name: 'SpinsConsumeTotal',
  components: {
    GrantPercentStat,
    statBar
  },
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    typ: {
      type: String,
      default: () => '+'
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      titleArr: [],
      queryParams: {
        lang: '+'
      },
      rewardArr: [14, 15],
      ridType: [],
      tableData: [],
      pageSize: 10, // 每页显示的图例和系列数量
      currentPage: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          // type: 'scroll',
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '7%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} %' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            const x = point[0]
            const y = '5%'// 向下移动 20 像素
            return [x, y]
          },
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: []
      }
      this.chart.setOption(this.option)
    },
    getTables() {
      this.queryParams.lang = this.typ
      for (const i in this.params) {
        this.queryParams[i] = this.params[i]
      }
      getRidData(this.queryParams).then(res => {
        this.titleArr = []
        this.tableData = res.data
        if (this.tableData.length <= 0) {
          this.initChart()
          return
        }
        if (res.data.length > 0) {
          const val = res.data[0].data
          for (const i in val) {
            this.titleArr.push(val[i].title)
          }

          const echart = {}
          const echart2 = {}
          const date = []
          for (const i in this.tableData) {
            date.push(dateStrTodate(this.tableData[i].date))
            const val = this.tableData[i].data
            const total = this.tableData[i].num
            for (const k in val) {
              const v = val[k]
              if (echart[v.title] === undefined) {
                echart[v.title] = []
                echart2[v.title] = []
              }
              let rate = 0
              if (total > 0) {
                rate = (v.num / total * 100).toFixed(2)
              }
              echart[v.title].push(rate)
              echart2[v.title].push(v.num)
            }
          }

          const titleArr = []
          for (const i in echart) {
            titleArr.push(i)
            const temp = {
              name: i,
              data: echart[i],
              type: 'line',
              label: {
                // show: true,
                position: 'top', // 标签显示在折线图顶部
                formatter: '{c}' // 显示数值
              }
            }
            this.option.series.push(temp)
          }
          if (this.title === '产出占比') {
            this.option.grid.bottom = '25%'
          }
          this.option.legend.data = titleArr
          this.option.xAxis.data = date
          this.chart.setOption(this.option, true)
          this.$refs.statBar.updateChart(titleArr, date, echart2)
        }
      })
      if (this.rewardArr.includes(this.queryParams.type)) {
        this.$refs.grantPercent.getTables(this.queryParams.type === 14 ? 2 : 1)
      }
    },
    numFormatter2(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 15px;
}
</style>
